<template>
	<div class="buttons">
		<a v-if="showTagsLink && tagFields.length > 1" href @click.prevent="$root.$emit('toggle-drawer', DRAWERS.MANAGE_TAGS)" class="button"><div class="hover-title">Tags</div><span class="fa fa-tags"></span></a>
		<router-link v-if="showTagsLink && tagFields.length === 1" :to="tagFields[0].type === 'tags' ? `/module/${module.slug}/tags/${tagFields[0].id}` : `/module/${ tagFields[0].specific_data }`" exact class="button"><div class="hover-title">{{ tagFields[0].name }}</div><span class="fa fa-tags"></span></router-link>

		<a href v-if="triggers.length > 1" @click.prevent="$root.$emit('toggle-drawer', DRAWERS.LIST_TRIGGERS)" class="button"><div class="hover-title">Show Actions</div><span class="fa fa-location" ></span></a>
		<trigger-button v-for="trigger in buttonTriggers" :key="`${ module.id }-row-${ parentRow.id }-trigger-${ trigger.id }`" :trigger="trigger" :module="module" :row="parentRow"></trigger-button>
		<router-link v-for="button in moduleHeader.buttons" :to="button.link" :target="button.target || '_self'" :key="`${ $route.params.slug }-${ $route.name }-${ button.link }`" exact class="button"><div class="hover-title">{{ button.title }}</div><span class="fa" :class="button.icon || 'fa-question-circle'"></span></router-link>
		<slot></slot>

		<drawer :name="DRAWERS.LIST_TRIGGERS" :shrink="true">
			<list-triggers-drawer :module="module" :row="parentRow"></list-triggers-drawer>
		</drawer>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { DRAWERS } from '@/constants';
import TriggerButton from '../../../../components/TriggerButton';
import ListTriggersDrawer from '@/views/sections/app/modules/drawers/ListTriggersDrawer';

export default {

	props: {
		showTags: {
			type: Boolean,
			default: false
		},
		// Whether this is the heading of a manage page (an update page with child modules)
		parentRow: {
			type: Object,
			default: () => ({})
		},
	},

	data() {
		return {
			DRAWERS,
		};
	},

	computed: {
		...mapGetters([ 'module', 'moduleHeader' ]),

		tagFields() {
			return this.moduleHeader.tags.fields || [];
		},

		showTagsLink() {
			/*
			 * TODO - Right now the 'Manage Tags' page doesn't have the module boilerplate we get from api /list
			 *  We need to make it receive that so it can show the manage tags drawer here as well
			 */

			// return this.tagFields && [ 'list', 'tags' ].indexOf(this.$route.name) !== -1;
			return this.showTags || (this.tagFields && [ 'list' ].indexOf(this.$route.name) !== -1);
		},

		triggers() {
			if (this.$route.name === 'create') return [];

			return (this.module.triggers || []).filter(trigger => {
				return trigger.button_locations.includes(this.triggerLocation);
			});
		},

		buttonTriggers() {
			if (this.triggers.length > 1) return [];

			return this.triggers;
		},

		triggerLocation() {
			return Object.keys(this.parentRow).length > 0 ? 'update' : 'index_top';
		}
	},

	components: {
		ListTriggersDrawer,
		TriggerButton,
	},
};

</script>
